import React, { useState, useContext, useEffect } from 'react'
import { PlayerProfileContext } from '../../../../Context'
import { EventGQL } from '../../../../Api'
import { EventBox } from '../../../../Components/GameTicker/EventBox/EventBox'
import { SectionHeading } from '../../../../Components/Headers'
import { Box } from '../../../../Components/Layout'
import { GamesRow } from './styles'

export const UpcomingGames: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { playerEvents, team } = useContext(PlayerProfileContext)!
  const color = team?.teamColor || undefined
  const [upcomingGame, setUpcomingGame] = useState<EventGQL | null>(null)
  const [headingText, setHeadingText] = useState<string>('Next Game')
  useEffect(() => {
    let upcoming = playerEvents.find((ev) => ev.eventStatus < 2)
    if (!upcoming) {
      return
    }
    setHeadingText(upcomingGame?.eventStatus === 1 ? 'Playing Now!' : 'Next Game')
    setUpcomingGame(upcoming)
  }, [playerEvents])

  return (
    <>
      {upcomingGame && (
        <Box>
          <SectionHeading teamColor={color} headingText={headingText} />
          <GamesRow>
            <EventBox eventData={upcomingGame} />
          </GamesRow>
        </Box>
      )}
    </>
  )
}
